module.exports = __webpack_public_path__ + "static/jtwp470-2223bb3cf0fc523daff462cd17da6853.jpg";